import { InjectionToken } from '@angular/core';

export type Config = {
    [key: string]: any;
};

export const LOCAL_CONFIG_OVERRIDES = new InjectionToken<Config>('Local app config overrides');
export const LOCAL_CONFIG = new InjectionToken<Config>('Local app config');
